import { Button, Label, TextInput } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaArrowRight, FaCheck, FaEye, FaEyeSlash, FaTimes } from 'react-icons/fa';
import IdeosPay from '../../assets/Ideos.png'
import CTA from '../../assets/authImage.png'
import { Link, useNavigate } from 'react-router-dom'
import PublicLayout from '../../layouts/PublicLayout';
import * as styles from './CreateAccount.styles'
import Form from '../../components/Form/Form';
import CustomInput from '../../components/CustomInputs/CustomInput';
import CustomButton from '../../components/CustomButton/CustomButton';
import CustomLink from '../../components/CustomLinks/CustomLink';
import api from '../../api';
import { SignupPayload } from './createAccountInterface';
import showToast from '../../components/CustomToast/toastHelper';
import client from '../../api/client';

const CreateAccount = () => {
    const navigate = useNavigate()
    const [formValues, setFormValues] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        businessName: '',
        password: '',
        cpassword: ''
    });
    const [isLengthValid, setIsLengthValid] = useState<boolean>(false);
    const [isUppercaseValid, setIsUppercaseValid] = useState<boolean>(false);
    const [isLowercaseValid, setIsLowercaseValid] = useState<boolean>(false);
    const [isNumberValid, setIsNumberValid] = useState<boolean>(false);
    const [isSpecialCharValid, setIsSpecialCharValid] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState<boolean>(false)
    const [showcPassword, setShowCPassword] = useState<boolean>(false)
    const [loading, setLoading]= useState<boolean>(false)
    const [isPasswordFocused, setIsPasswordFocused] = useState<boolean>(false);
    const [isFormValid, setIsFormValid] = useState<boolean>(false)
    

    const validatePassword = (password: string) => {
        setIsLengthValid(password.length >= 8);
        setIsUppercaseValid(/[A-Z]/.test(password));
        setIsLowercaseValid(/[a-z]/.test(password));
        setIsNumberValid(/[0-9]/.test(password));
        setIsSpecialCharValid(/[!@#$%^&*()”?/]/.test(password));
    };

    const passwordConditions = [
        {
            condition: isLengthValid,
            text: "At least 8+ characters"
        },
        {
            condition: isUppercaseValid && isLowercaseValid,
            text: "Both lowercase (a-z) & uppercase letters (A-Z)"
        },
        {
            condition: isNumberValid,
            text: " At least 1 number"
        },
        {
            condition: isSpecialCharValid,
            text: "Contains a special character (!@#$%^&*()”?/)"
        }
    ]

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value.trim()
        }));
    };
    let isFormFilled;
    useEffect(() => {
        validatePassword(formValues.password);
        // Check if all fields are filled
        isFormFilled = Object.values(formValues).every(value => value.trim() !== '');        
        setIsFormValid(isFormFilled);
        
    }, [formValues]);
    
    
    const getProgress = () => {
        const totalConditions = 4;
        const conditionsMet = passwordConditions.filter(passcondition => passcondition.condition).length;
        return (conditionsMet / totalConditions) * 100;
    };

    const renderValidationIcon = (isValid: boolean) => {
        return isValid ? (
            <FaCheck className="bg-custom-button-green text-white rounded-full p-1 mr-2" />
        ) : (
            <FaTimes className="bg-red-500 text-white rounded-full p-1 mr-2" />
        );
    };

    const togglePasswordVisibility = (field: 'password' | 'cpassword') => {
        if (field === 'password') {
            setShowPassword(!showPassword);
        } else if (field === 'cpassword') {
            setShowCPassword(!showcPassword);
        }
    };
    const confirmPasswordMatch = (password: string, cpassword: string) => {
        if (password === cpassword) return true
        return false
    }
    const handleSubmit = async(e:any) => {
        e.preventDefault()
        setLoading(true)
        //confirm password match
        if (!confirmPasswordMatch(formValues.password, formValues.password)) {
            showToast("Passwords do not match","error")
            return
        }

        const payload: SignupPayload = {
            firstName: formValues.firstName,
            lastName: formValues.lastName,
            userEmail: formValues.email,
            mobileNumber: formValues.phoneNumber,
            name: formValues.businessName,
            password: formValues.password,

        }
        try {
            const response = await client.post("/subsidiary/dashboard/signup",payload);
            
            if (response.data.status =="success") {
                //show toast with message
                showToast(response.data.message,"success")
                sessionStorage.setItem("email",formValues.email)
                navigate('/2fa/auth', {state:{email:formValues.email}});
            } else {
                console.error('Signup failed');
                showToast(response.data.message,"error")
                setLoading(false)
            }
        } catch (error:any) {
            // Handle request error
            console.error('API request failed', error);
            showToast(error.response.data.message, "error")
            setLoading(false)
        }
    }
    return (
        <PublicLayout>
            <div className={styles.container}>
                <div className={styles.formContainer}>
                    <Form title='Create your account' subtitle="">
                        <div>
                            <div className={styles.nameDiv}>
                                <CustomInput label='First name' value={formValues.firstName} onChange={handleChange} name='firstName' />
                                <CustomInput label='Last name' value={formValues.lastName} onChange={handleChange} name='lastName' />
                            </div>
                            <CustomInput label='Email Address' value={formValues.email} onChange={handleChange} name='email' />
                            <CustomInput label='Phone Number' name='phoneNumber' value={formValues.phoneNumber} onChange={handleChange} />
                            <CustomInput label='Business Name' name='businessName' value={formValues.businessName} onChange={handleChange} />
                            <CustomInput label='Password' type={showPassword ? 'text' : 'password'} name='password' value={formValues.password} onChange={handleChange} onRightIconClick={() => togglePasswordVisibility('password')} rightIcon={showPassword ? FaEye : FaEyeSlash} onFocus={() => setIsPasswordFocused(true)}
                                onBlur={() => setIsPasswordFocused(false)}/>
                            {isPasswordFocused &&(<div className="my-4">
                                <div className={styles.progessBarContainer}>
                                    <div
                                        className={styles.progessBar}
                                        style={{ width: `${getProgress()}%` }}
                                    ></div>
                                </div>
                                <p className={styles.passwordDescription}>Your password should contain:</p>
                                {passwordConditions.map(condition => (
                                    <div className={styles.passwordConditions}>
                                        {renderValidationIcon(condition.condition)}
                                        <span className={condition ? 'text-custom-button-green' : 'text-red-600'}>
                                            {condition.text}
                                        </span>
                                    </div>
                                ))}

                            </div>)}
                            <CustomInput label='Confirm password' name='cpassword' type={showcPassword ? 'text' : 'password'} value={formValues.cpassword} onChange={handleChange} onRightIconClick={() => togglePasswordVisibility('cpassword')} rightIcon={showcPassword ? FaEye : FaEyeSlash} />
                            <CustomButton onClick={handleSubmit} className={styles.button}  text='Next' loading={loading} icon={<FaArrowRight />} />

                            <div className={styles.buttonDiv}>
                                <p className={styles.link}>Already have an account? <CustomLink className={styles.customLink} to="/login" text="Login" /></p>

                            </div>
                        </div>

                    </Form>
                </div>
            </div >

        </PublicLayout >
    );
}

export default CreateAccount;
